export enum GenderEnum {
  FEMALE = 'FEMALE',
  MALE = 'MALE',
  NOT_KNOWN = 'NOT_KNOWN',
  NOT_APPLICABLE = 'NOT_APPLICABLE',
}
